import Quiniela from './Quiniela';
export default Quiniela;
